/** Idempotent registration, including StrictMode cleanup and multiple simultaneous editors. */
export function setBenefitEditorOpen(editors: Set<string>, id: string, open: boolean): boolean {
  if (open === editors.has(id)) return false
  if (open) editors.add(id)
  else editors.delete(id)
  return true
}

export function blockBenefitNavigation(openCount: number, current: { pathname: string; search: string }, next: { pathname: string; search: string }): boolean {
  return openCount > 0 && (current.pathname !== next.pathname || current.search !== next.search)
}
